@if (isLoading) {
  <app-loading-page
    [isFullScreen]="false"
    [message]="'Loading connectors'"
  ></app-loading-page>
}

@else {
  <div class="hotglue-container">
    <h2>Integrations</h2>
    @if (!linkedSources) {
      <p>Choose a connector for Skip</p>
    }

    @if (Connectors.length > 0) {
      <!-- Search Bar -->
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (input)="search()"
        placeholder="Search Source"
        class="search-bar"
      />

      <div class="grid-container">
        @for (connector of filteredConnectors; track connector) {
          <div class="connector-card" (click)="linkConnection(connector.id)">
            <!-- "LINKED" badge in the top-right corner if linked -->
            @if (connector.linked) {
              <div class="linked-badge">LINKED</div>
            }

            <!-- Connector Logo -->
            <img
              [src]="connector.logo"
              [alt]="connector.name"
              class="connector-logo"
            />

            <div>{{ connector.name }}</div>

            <span class="version">{{ connector.version }}</span>
          </div>
        }
      </div>
      <div class="pagination">
        @if (totalResults > pageSize) {
          <button (click)="prevPage()" [disabled]="page === 1">Previous</button>
          <span>{{ (page - 1) * pageSize + 1 }} - {{ getMinPageValue() }} of {{ totalResults }} results</span>
          <button (click)="nextPage()" [disabled]="page * pageSize >= totalResults">Next</button>
        }
      </div>
    }
  </div>
}
